import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { PortalPopover } from './PopoverStyled';

/**
 * Popover do seletor de módulos (modo collapsed), renderizado via portal.
 */
function ModulePopover({
   availableModules,
   activeModule = null,
   onSelect,
   onClose,
   anchorRef = null,
}) {
   const popoverRef = useRef(null);
   const [coords, setCoords] = useState({ top: 0, left: 0 });

   useLayoutEffect(() => {
      if (anchorRef?.current) {
         const rect = anchorRef.current.getBoundingClientRect();
         setCoords({ top: rect.top, left: rect.right + 10 });
      }
   }, [anchorRef]);

   useEffect(() => {
      const handler = (e) => {
         if (
            popoverRef.current &&
            !popoverRef.current.contains(e.target) &&
            anchorRef?.current &&
            !anchorRef.current.contains(e.target)
         ) {
            onClose();
         }
      };
      document.addEventListener('mousedown', handler);
      return () => document.removeEventListener('mousedown', handler);
   }, [onClose, anchorRef]);

   return ReactDOM.createPortal(
      <PortalPopover
         ref={popoverRef}
         role="menu"
         $top={coords.top}
         $left={coords.left}
      >
         <p className="portal-popover-title">Módulo</p>

         {availableModules.map(([key, config]) => {
            const active = activeModule === key;
            return (
               <button
                  key={key}
                  type="button"
                  role="menuitem"
                  className={`portal-popover-item ${active ? 'active' : ''}`}
                  onClick={() => {
                     onSelect(key);
                     onClose();
                  }}
               >
                  <span>{config.icon}</span>
                  <span className="portal-popover-label">{config.label}</span>
                  {active && <span className="portal-popover-active-dot" />}
               </button>
            );
         })}
      </PortalPopover>,
      document.body
   );
}

ModulePopover.propTypes = {
   availableModules: PropTypes.arrayOf(PropTypes.array).isRequired,
   activeModule: PropTypes.string,
   onSelect: PropTypes.func.isRequired,
   onClose: PropTypes.func.isRequired,
   anchorRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default ModulePopover;
